/**
 * Auth Utilities
 * No more localStorage - using httpOnly cookies only
 */

import { removeAllAuthCookies } from './cookie.utils';
import { logger } from './logger';

/**
 * Clear all auth data (cookies only)
 */
export function clearAllAuthData(): void {
  if (typeof window === 'undefined') return;

  localStorage.removeItem('is_authenticated');

  // Clear client-side cookies (non-httpOnly ones if any)
  removeAllAuthCookies();

  logger.log('🗑️ All auth data cleared');
}

export const hasAuthToken = (): boolean => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem('is_authenticated') === 'true';
};
